import { Form, Input, Select } from "antd"

export default () => {
  return [
    {
      label: 'Төхөөрөмжийн нэр',
      name: 'name',
      rules: [{required: true, message: 'Төхөөрөмжийн нэр оруулна уу!'}],
      className: 'col-span-12 md:col-span-12 mb-0',
      inputProps: {
        className: 'w-full',
      }
    },
  ]
}